import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, SelectItem } from "primeng/api";
import { PerfilRiesgo } from "../../../../_models/perfil-riesgo";
import { ListaItem } from "../../../../_models/lista-item";
import { NavService } from "../../../../_services/_nav.service";
import { FlujoVentaPasoRestriccionPerfilVinculacion } from "../../../../_models/flujo-venta-paso-restriccion-perfil-vinculacion";
import { FlujoVentaPasoRestriccionPerfilVinculacionService } from "../../../../_services/flujo-venta-paso-restriccion-perfil-vinculacion.service";
import { forkJoin } from "rxjs";
import { TabViewCustom } from "../../../../_models/tab-view-custom";
import { ListaService } from "../../../../_services/lista.service";
import { PerfilRiesgoService } from "../../../../_services/perfil-riesgo.service";

@Component({
  selector: "app-fv-restricciones-perfil-x-vinculacion",
  templateUrl: "./fv-restricciones-perfil-x-vinculacion.component.html",
  styleUrls: ["./fv-restricciones-perfil-x-vinculacion.component.css"],
})
export class FvRestriccionesPerfilXVinculacionComponent implements OnInit {
  @Input() tabView: TabViewCustom;
  formulario: FormGroup;
  listaVinculaciones: SelectItem[] = [];
  listaVinculacionesTodos: ListaItem[] = [];
  listaPerfilesRiesgo: SelectItem[] = [];
  listaPerfilesRiesgoTodos: PerfilRiesgo[] = [];
  lisRestriccionesPerfilXVinculacion: FlujoVentaPasoRestriccionPerfilVinculacion[] = [];
  lisRestriccionesPerfilXVinculacionTodos: FlujoVentaPasoRestriccionPerfilVinculacion[] = [];
  submitted = false;
  cargando = true;
  guardando = false;
  columnas: any[];

  constructor(
    private navServicio: NavService,
    private fb: FormBuilder,
    private flujoVentaPasoRestriccionPerfilVinculacionService: FlujoVentaPasoRestriccionPerfilVinculacionService,
    private listaService: ListaService,
    private perfilRiesgoService: PerfilRiesgoService,
    private confirmService: ConfirmationService
  ) {}

  ngOnInit() {
    this.setearColumnas();
    this.listaVinculacionesTodos = [];
    this.listaPerfilesRiesgoTodos = [];

    forkJoin(
      this.listaService.getMasterDetails("ListasTiposVinculaciones"),
      this.perfilRiesgoService.listadoHabilitados()
    ).subscribe(([listaVinculaciones, listaPerfilesRiesgo]) => {
      this.listaVinculacionesTodos = listaVinculaciones;
      this.listaPerfilesRiesgoTodos = listaPerfilesRiesgo;
      this.cargarFormulario();
      this.cargaInicial();
    });
  }

  /* carga inicial de datos */
  cargaInicial() {
    this.cargando = true;
    this.listaVinculaciones = [];
    this.listaPerfilesRiesgo = [];
    this.lisRestriccionesPerfilXVinculacion = [];

    forkJoin(
      this.flujoVentaPasoRestriccionPerfilVinculacionService.obtenerPorFlujoVentaPaso(
        this.tabView.flujoVenta.idFlujoVentaPaso
      )
    ).subscribe(([lisRestriccionesPerfilXVinculacion]) => {
      this.lisRestriccionesPerfilXVinculacionTodos = lisRestriccionesPerfilXVinculacion;
      lisRestriccionesPerfilXVinculacion.map((x) => {
        if (x.indicadorHabilitado) {
          this.lisRestriccionesPerfilXVinculacion.push(x);
        }
      });
      this.validarListas();
      this.cargando = false;
      this.guardando = false;
    });
  }

  /* columnas del data table */
  setearColumnas() {
    this.columnas = [
      {
        field: "tipoVinculacion",
        header: this.navServicio.buscarMensaje(
          "FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_VINCULACION"
        ),
        sort: true,
      },
      {
        field: "perfilRiesgo",
        header: this.navServicio.buscarMensaje(
          "FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_PERFILERIESGO"
        ),
        sort: true,
      },
      {
        field: "acciones",
        header: this.navServicio.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      },
    ];
  }

  /* carga del formulario */
  cargarFormulario() {
    this.formulario = this.fb.group({
      idsVinculaciones: [null, [Validators.required]],
      idsPerfilesRiesgos: [null, [Validators.required]],
    });
  }

  /* validar y llenar las listas necesarias */
  validarListas() {
    let contadorVinculaciones = 0;
    let contadorPerfilesRiesgo = 0;

    /* verificar si la vinculacion tiene todas las combinaciones posible para quitarla de la lista */
    this.listaVinculacionesTodos.map((x) => {
      this.listaPerfilesRiesgoTodos.map((s) => {
        if (
          this.lisRestriccionesPerfilXVinculacion.find(
            (e) =>
              e.idTipoVinculacion === x.idLista &&
              e.idPerfilRiesgo === s.idPerfilRiesgo
          )
        ) {
          contadorPerfilesRiesgo++;
        }
      });
      if (contadorPerfilesRiesgo != this.listaPerfilesRiesgoTodos.length) {
        this.listaVinculaciones.push({ label: x.nombre, value: x.idLista });
      }
      contadorPerfilesRiesgo = 0;
    });

    /* verificar si el perfil de riesgo tiene todas las combinaciones posible para quitarla de la lista */
    this.listaPerfilesRiesgoTodos.map((x) => {
      this.listaVinculacionesTodos.map((s) => {
        if (
          this.lisRestriccionesPerfilXVinculacion.find(
            (e) =>
              e.idPerfilRiesgo === x.idPerfilRiesgo &&
              e.idTipoVinculacion === s.idLista
          )
        ) {
          contadorVinculaciones++;
        }
      });
      if (contadorVinculaciones != this.listaVinculacionesTodos.length) {
        this.listaPerfilesRiesgo.push({
          label: x.nombreRiesgo,
          value: x.idPerfilRiesgo,
        });
      }
      contadorVinculaciones = 0;
    });
  }

  /* guardar */
  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.guardando = true;
      let contadorResgistrosYaConfigurados = 0;
      let registros: FlujoVentaPasoRestriccionPerfilVinculacion[] = [];
      this.formulario.value.idsVinculaciones.map((x) => {
        this.formulario.value.idsPerfilesRiesgos.map((s) => {
          let obj = {} as FlujoVentaPasoRestriccionPerfilVinculacion;
          const existe = this.lisRestriccionesPerfilXVinculacionTodos.find(
            (e) => e.idTipoVinculacion === x && e.idPerfilRiesgo === s
          );
          if (existe && existe.indicadorHabilitado) {
            contadorResgistrosYaConfigurados++;
          }
          if (existe && !existe.indicadorHabilitado) {
            existe.indicadorHabilitado = true;
            registros.push(existe);
          } else if (!existe) {
            obj.idFlujoVentaPaso = this.tabView.flujoVenta.idFlujoVentaPaso;
            obj.idTipoVinculacion = x;
            obj.idPerfilRiesgo = s;
            obj.indicadorHabilitado = true;
            registros.push(obj);
          }
        });
      });
      if (registros.length > 0) {
        this.flujoVentaPasoRestriccionPerfilVinculacionService
          .bulk(registros)
          .subscribe(
            (res) => {
              this.navServicio.setMesage(1);
              if (contadorResgistrosYaConfigurados > 0) {
                this.showMessage("LBL_INFORMACION", "FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_YACONFIGURADAS");
              }
              this.formulario.reset();
              this.submitted = false;
              this.cargaInicial();
            },
            (error) => {
              this.navServicio.setMesage(3);
              this.formulario.reset();
              this.submitted = false;
              this.guardando = false;
            }
          );
      } else {
        this.showMessage("LBL_INFORMACION", "FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_YACONFIGURADAS");
        this.formulario.reset();
        this.submitted = false;
        this.guardando = false;
      }
    }
  }

  /* controls del formulario */
  get f() {
    return this.formulario.controls;
  }

  /* inhabilitar un registro */
  inhabilitar(row: FlujoVentaPasoRestriccionPerfilVinculacion) {
    this.confirmService.confirm({
      message: this.navServicio.buscarMensaje("MSG_INHABILITAR"),
      header: this.navServicio.buscarMensaje("LBL_CONFIRMACION"),
      icon: "fa fa-question-circle",
      key: "form-paso-flujo-restriccion-" + this.tabView.codigo,
      accept: () => {
        this.guardando = true;
        row.indicadorHabilitado = false;
        this.flujoVentaPasoRestriccionPerfilVinculacionService
          .actualizar(row)
          .subscribe(
            (res) => {
              this.navServicio.setMesage(2);
              this.formulario.reset();
              this.submitted = false;
              this.cargaInicial();
            },
            (error) => {
              this.navServicio.setMesage(3);
              this.formulario.reset();
              this.submitted = false;
              this.guardando = false;
            }
          );
      },
      reject: () => {},
    });
  }

  private showMessage(
    titulo: string,
    mensaje: string,
    severity: string = "info"
  ) {
    this.navServicio.setMesage(0, {
      severity: severity,
      summary: this.navServicio.buscarMensaje(titulo),
      detail: this.navServicio.buscarMensaje(mensaje),
    });
  }
}
